import localDB from "./localDB";
let GLOBAL = require('./globals');

const SecurityStoreData = {
    async get(res) {
        await fetch(`${GLOBAL.BASE_URL}store-security`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}store-security`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(err));
    }
};

export default SecurityStoreData;


// WEBPACK FOOTER //
// ./src/data/SecurityStoreData.js